<template>
  <div>
    <fieldset class="fieldset">
      <p class="purchase-type-titles my-5">
        Select a financial option
      </p>
      <div class="field">
        <div class="control radio-list">
          <label
            v-for="(label, value) in stepOptions"
            :key="value"
            class="radio is-flex custom-radio"
            style="align-items: center"
          >
            <input v-model="updates.purchaseType" type="radio" :value="value" />
            <span class="radio-indicator"></span>
            <span class="radio-label ml-1 mr-1">{{ label }}</span>
            <b-tooltip position="is-right">
              <span v-if="value == 'sale'" class="link-color">
                <icon type="warning-circle" />
              </span>
              <template v-slot:content>
                <span>If purchasing, modifications will be available</span>
              </template>
            </b-tooltip>
          </label>
        </div>

        <div v-if="updates.purchaseType == 'rental'" class="control radio-list">
          <p class="purchase-type-titles mb-5">
            How long will you want the container for?
          </p>
          <validation-provider rules="required" tag="div" class="radio-labels">
            <label
              v-for="(label, value) in rentalTime"
              :key="value"
              class="radio custom-radio"
            >
              <input v-model="updates.rentalTime" type="radio" :value="value" />
              <span class="radio-indicator"></span>
              <span class="radio-label">{{ label }}</span>
            </label>
          </validation-provider>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { DynamicStep } from './mixin'
import Icon from './helpers/icon.vue'
export default {
  mixins: [ DynamicStep('purchaseType') ],
  components: {
    Icon
  },
  computed: {
    ...mapState('shared', [ 'phoneNumber' ]),
    ...mapState('quote', [ 'city' ])
  },
  data() {
    return {
      rentalTime: {
        short: 'Short-term (monthly)',
        long: 'Long-term (ongoing permanent use)',
        notSure: 'Not sure'
      }
    }
  }
}
</script>

<style scoped>
.radio-list .custom-radio {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.radio-list input[type="radio"] {
  display: none;
}

.radio-indicator {
  width: 18px;
  height: 18px;
  border: 1px solid #D4CBBF;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  position: relative;
  background-color: #FFFFFF;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.radio-indicator::before {
  content: "";
  width: 10px;
  height: 10px;
  background-color: #FFFFFF;
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.radio-list input[type="radio"]:checked + .radio-indicator {
  background-color: #4D84FF;
  border-color: #4D84FF;
}

.radio-list input[type="radio"]:checked + .radio-indicator::before {
  opacity: 1;
}

.radio-label {
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 24px !important;
  letter-spacing: -0.0125em !important;
  color: #334155 !important;
}

.purchase-type-titles {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.0125em;
  color: #334155;
}
</style>
